const ZONE_KEY = 'admin_zone_id';

export const getStoredZoneId = () => localStorage.getItem(ZONE_KEY) || '';

export const setStoredZoneId = (zoneId) => {
  if (!zoneId) {
    localStorage.removeItem(ZONE_KEY);
    return;
  }
  localStorage.setItem(ZONE_KEY, zoneId);
};

export const clearStoredZoneId = () => {
  localStorage.removeItem(ZONE_KEY);
};
